<script lang="ts">
	import { ArrowRight, Gift } from 'lucide-svelte';
	import { Badge } from '$lib/components/ui/badge';
	import { Button } from '$lib/components/ui/button';
	import * as Card from '$lib/components/ui/card';

	type GiftCard = {
		amount: number;
		currency: string;
		description: string;
		image: string;
		title: string;
		url: string;
	};

	let { giftCard }: { giftCard: GiftCard } = $props();
</script>

<Card.Root
	class="group relative flex h-full w-full flex-col overflow-hidden rounded-2xl border-none bg-muted shadow-none"
>
	<Card.Header class="relative w-full p-0">
		<div class="relative h-56 w-full overflow-hidden rounded-t-2xl bg-white">
			<img
				alt={`Tassie Tours ${giftCard.title}`}
				class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
				src={giftCard.image}
				loading="lazy"
				width="800"
				height="600"
			/>
			<div
				class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"
			></div>
			<Badge class="absolute left-4 top-4 bg-[#ffd451] text-foreground hover:bg-[#ffd451]/80">
				Gift card
			</Badge>
			<div class="absolute bottom-0 left-0 right-0 px-4 pb-4">
				<h3 class="font-heading text-lg font-semibold leading-snug text-white">
					{giftCard.title}
				</h3>
			</div>
		</div>
		<div class="flex items-center gap-2 px-4 pb-3 pt-4">
			<span class="text-base font-semibold">
				{giftCard.currency} ${giftCard.amount.toFixed(2)}
			</span>
			<span class="flex items-center gap-1 text-sm text-muted-foreground">
				<Gift class="h-3.5 w-3.5" />
				Digital gift card
			</span>
		</div>
	</Card.Header>
	<Card.Content class="flex-1 px-4 pb-5 pt-0">
		<p class="line-clamp-3 text-sm text-muted-foreground">{giftCard.description}</p>
	</Card.Content>
	<Card.Footer class="px-4 pb-4">
		<Button
			href={giftCard.url}
			target="_blank"
			rel="noopener noreferrer"
			class="rounded-full bg-tt-red px-5 font-semibold text-white hover:bg-tt-red/90"
			aria-label={`Buy a ${giftCard.title} through Rezdy (opens in a new tab)`}
		>
			Buy gift card <ArrowRight class="h-4 w-4" />
		</Button>
	</Card.Footer>
</Card.Root>
